import { Component, Input } from "@angular/core";
import { IStepAssignee } from "../../../interfaces/step";
import { LogClass, Logger } from "../../../logger";

@Component({
    selector: "circ-task-details",
    templateUrl: "./task-details.component.html",
    styleUrls: ["./task-details.component.scss"],
    standalone: false
})
@LogClass({ source: "TaskDetailsComponent" })
export class TaskDetailsComponent {
  private logger: Logger;
  @Input() public assignee: IStepAssignee;
  @Input() public showName: boolean;
  @Input() public showImage: boolean;

  constructor() {
    this.logger.debug("init");
  }
}
